import { memo, useState } from 'react';
// import { Select } from 'antd';
import { ItemEat } from '@components/ItemEat';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectBannerShoping,
  // selectCategory,
  selectIsLoading,
  selectShoping,
} from './selectors';
import LoadingContainer from '@components/LoadingContainer';
import { PageBanner } from '@components/PageBanner';
import { EatWrapper } from '@containers/Eat/style';
import { GET_SHOPING } from './slice';
import { selectTranslate } from '@containers/Home/selectors';
import { useRouter } from 'next/router';

// const { Option } = Select;

interface EatProps {
  park: string;
}

const ShopingPage = memo(({ park }: EatProps) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const banner = useSelector(selectBannerShoping);
  const shoping = useSelector(selectShoping);
  // const category = useSelector(selectCategory);
  const loading = useSelector(selectIsLoading);
  const translate = useSelector(selectTranslate);

  // const [themePark, setThemePark] = useState('');
  const [limit, setLimit] = useState(10);

  // const handleCate = useCallback(
  //   (key: string) => {
  //     if (key === themePark) return;
  //     setThemePark(key);
  //     setLimit(10);
  //     dispatch(GET_SHOPING({ SiteCode: park, key }));
  //   },
  //   [dispatch, park, themePark],
  // );
  return (
    <EatWrapper>
      <PageBanner banner={banner} />
      <div className="eatListing">
        <div className="container-fluid">
          <div className="--top">
            <div className="--title">
              <div className="titleFrame">
                {translate
                  ? translate[`SunParadiseLand.shoppingDestination`]
                  : ''}
              </div>
              <div className="--total">
                {shoping?.paginator?.totalCount}{' '}
                {translate ? translate[`SunParadiseLand.locations`] : ''}
              </div>
            </div>
            {/* <div className="--filter">
              <Select
                placeholder="Giá từ"
                suffixIcon={<i className="fa-solid fa-angle-down" />}
              >
                <Option value="option1">100.000Vnđ</Option>
              </Select>
              <div className="--note">
                Bộ lọc <i className="fa-regular fa-filter" />
              </div>
            </div> */}
          </div>
          {/* <div className="TabPage">
            <div
              className={`--item ${themePark === '' ? 'active' : ''}`}
              onClick={() => handleCate('')}
            >
              <i className="fa-regular fa-list" /> Tất cả
            </div>
            {category?.map(item => (
              <div
                key={item.id}
                className={`--item ${item.key === themePark ? 'active' : ''}`}
                onClick={() => handleCate(item.key)}
              >
                {item.name} {item.count ? `(${item.count})` : ''}
              </div>
            ))}
          </div> */}
          <LoadingContainer loading={loading}>
            {shoping?.data?.length > 0 ? (
              <>
                <div className="--listEat">
                  {shoping?.data?.map((item, i) => (
                    <ItemEat key={i} item={item} />
                  ))}
                </div>
                {limit < shoping?.paginator?.totalCount && (
                  <div
                    className="--addEat btn btn-2"
                    onClick={() => {
                      setLimit(prevLimit => {
                        const newLimit = prevLimit + 10;
                        dispatch(
                          GET_SHOPING({
                            SiteCode: park,
                            // key: themePark,
                            limit: newLimit,
                            locale: router.locale,
                          }),
                        );
                        return newLimit;
                      });
                    }}
                  >
                    {translate ? translate[`SunParadiseLand.viewMore`] : ''}
                  </div>
                )}
              </>
            ) : (
              <div className="noData">
                {translate ? translate[`SunParadiseLand.noData`] : ''}
              </div>
            )}
          </LoadingContainer>
        </div>
      </div>
    </EatWrapper>
  );
});

export default ShopingPage;
